import { ReactComponent as LogoCloud } from 'img/icons/logo_cloud.svg';
import { ReactComponent as LogoTeams } from 'img/icons/logo_teams_32.svg';
import React, { type FC, useRef } from 'react';
import { IS_B2B_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { MobileAppPromoTooltip } from 'reactApp/ui/ReactViewer/ViewerHeader/MobileAppPromoTooltip';
import opener from 'reactApp/utils/opener';

import styles from './MenuLogo.css';

const handleClick: React.MouseEventHandler = (e) => {
    e.stopPropagation();
    opener('/home', true);
};

export const MenuLogo: FC = () => {
    const logoRef = useRef<HTMLDivElement>(null);
    const [LogoIcon, hintText] = IS_B2B_BIZ_USER ? [LogoTeams, 'Диск VK WorkSpace'] : [LogoCloud, 'Облако Mail'];

    return (
        <>
            <MobileAppPromoTooltip elementRef={logoRef} />
            <div className={styles.logo} ref={logoRef}>
                <Hint theme="dark" text={hintText} delay={500} showDelay>
                    <LogoIcon className={styles.icon} height={32} width={32} onClick={handleClick} data-qa-isBiz={IS_B2B_BIZ_USER} />
                </Hint>
            </div>
        </>
    );
};
